import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import type DesktopPhotoPrompt from '../../../components/desktop-photo-prompt';
import type { IdDocImageUploadError } from '../../../types';
import { useNonIdDocMachine } from '../../context/non-id-doc-context';
import useDocName from '../../use-doc-name';
import DesktopRetryView from './desktop-retry-view';
const DesktopRetry = () => {
  const $ = _c(14);
  const [state, dispatch] = useNonIdDocMachine();
  const {
    requirement,
    errors,
    hasBadConnectivity,
    allowPdf
  } = state.context;
  const docName = useDocName(requirement.config);
  let t0;
  if ($[0] !== dispatch) {
    t0 = () => dispatch({
      type: "navigatedToPrompt"
    });
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClickBack = t0;
  let t1;
  if ($[2] !== dispatch) {
    t1 = payload => dispatch({
      type: "receivedDocument",
      payload
    });
    $[2] = dispatch;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleComplete = t1;
  let t2;
  if ($[4] !== dispatch) {
    t2 = errs => {
      dispatch({
        type: "uploadErrored",
        payload: {
          errors: errs.map(_temp)
        }
      });
    };
    $[4] = dispatch;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleUploadError = t2;
  let t3;
  if ($[6] !== allowPdf || $[7] !== docName || $[8] !== errors || $[9] !== handleClickBack || $[10] !== handleComplete || $[11] !== handleUploadError || $[12] !== hasBadConnectivity) {
    t3 = <DesktopRetryView docName={docName} errors={errors} hasBadConnectivity={hasBadConnectivity} allowPdf={allowPdf} onBack={handleClickBack} onComplete={handleComplete} onUploadError={handleUploadError} />;
    $[6] = allowPdf;
    $[7] = docName;
    $[8] = errors;
    $[9] = handleClickBack;
    $[10] = handleComplete;
    $[11] = handleUploadError;
    $[12] = hasBadConnectivity;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
export default DesktopRetry;
function _temp(err) {
  return {
    errorType: err
  };
}